export default __webpack_public_path__ + "static/media/coinbase.437f7178.svg";